export default "__VITE_PUBLIC_ASSET__5c56ded7__"